import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import CardHome from "../Home/CardHome";
import enveloppeIcon from '../../assets/icon/envelope.svg';
import euroIcon from '../../assets/icon/circle-euro.svg';
import fileIcon from '../../assets/icon/file-lines.svg';
import GIESvgIcon from "../../components/GIEIcon/GIESvgIcon";

export default class MyDocument extends React.Component<any, any> {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Mes documents"
                                                                      href="documents"
                                                                      title="Quels documents souhaitez-vous consulter ?"/>}>
          <div className="container-xl mb-5">
            <div className="row g-4">
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="MES DEVIS"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={enveloppeIcon}/>}
                          link="Accéder aux documents"
                          url='/admin/mes-devis'/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="MES FACTURES"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={euroIcon}/>}
                          link="Accéder aux documents"
                          url='/admin/mes-factures'/>
              </div>
              <div className="col-xs-12 col-lg-4">
                <CardHome firstTitle="MES FICHES D'INTERVENTION"
                          secondTitle=" "
                          icon={<GIESvgIcon big icon={fileIcon}/>}
                          link="Accéder aux documents"
                          url='/admin/mes-fiches-d-intervention'/>
              </div>
            </div>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
